import { SvgIcon } from "@mui/material";
import React from "react";

function FinanceIcon(props) {
  return (
    <SvgIcon viewBox="0 0 22 22" {...props}>
      <path
        d="M17.6915 7.25986V11.9807C17.6915 14.8041 16.0782 16.014 13.6582 16.014H5.60071C5.18821 16.014 4.79404 15.9774 4.42738 15.8949C4.19821 15.8582 3.97822 15.7941 3.77655 15.7207C2.40155 15.2074 1.56738 14.0157 1.56738 11.9807V7.25986C1.56738 4.43653 3.18071 3.22656 5.60071 3.22656H13.6582C15.7116 3.22656 17.1874 4.09739 17.5815 6.08656C17.6457 6.45322 17.6915 6.82903 17.6915 7.25986Z"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4426 10.0092V14.7301C20.4426 17.5534 18.8293 18.7634 16.4093 18.7634H8.3518C7.67347 18.7634 7.05931 18.6718 6.52764 18.4701C5.43681 18.0668 4.6943 17.2326 4.42847 15.8943C4.79513 15.9768 5.1893 16.0134 5.6018 16.0134H13.6593C16.0793 16.0134 17.6926 14.8034 17.6926 11.9801V7.25924C17.6926 6.82841 17.656 6.44344 17.5826 6.08594C19.3243 6.4526 20.4426 7.68091 20.4426 10.0092Z"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.62338 12.0432C10.9599 12.0432 12.0434 10.9597 12.0434 9.62314C12.0434 8.28661 10.9599 7.20312 9.62338 7.20312C8.28685 7.20312 7.20337 8.28661 7.20337 9.62314C7.20337 10.9597 8.28685 12.0432 9.62338 12.0432Z"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.38159 7.60938V11.6427"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8699 7.60938V11.6427"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default FinanceIcon;
